import React from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="nav">
      <div className="logo"><img src={'https://qiniures.rumcn.com/image/logo_long.png'} width={190} /></div>
      <div className="nav-links">
        {/* <Link to="home" smooth={true} duration={500} className="nav-link">首页</Link> */}
        {/* <Link to="pricing" smooth={true} duration={500} className="nav-link">定价</Link> */}
      </div>
    <a href={'https://mcn.rumcn.com/user/login'} target="_blank"><button className="trial-button">免费试用</button></a>
    </nav>
  );
};

export default Navbar; 